<template>
  <div class="container">
      <div class="header fd">
        <img class="top" src="../assets/img/home1.png" />
      <img class="middle" src="../assets/img/home2.png" />
      </div>
      <img class="top" src="../assets/img/home3.png" />
    <div class="image-box">
      <div 
        class="btn button glass ech-shake-time" 
        @click="handleClick"
      >
        点击定制你的高考幸运海报
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { Dialog } from "vant";
import { wxCloseWindow } from "@/plugins/wechatSDK.js"
import "@/plugins/bridge.js" 

export default {
  name: "Home",
  components: {
  },
  setup() {
    const router = useRouter();
    const store = useStore();

    store.dispatch("getAppEnv");

    const curtime = Date.parse(new Date());
    if ( curtime > 1654261199000 && curtime < 1654380000000) {
      Dialog.alert({
        message: '系统维护，6月5日恢复正常使用，敬请谅解。',
      }).then(() => {
        closePage();
      });
    }

    const closePage =()=> {
      const userAgentString = navigator.userAgent.toLowerCase()
      if (userAgentString.indexOf("zsrbapp") >= 0) {
        window.ZsrbApp.call("back")
      } else {
        wxCloseWindow();
      } 
    }

    const handleClick = () => {
      router.push("/submit");
    };
    return {
      handleClick,
      closePage,
      curtime,
    }
  },
}
</script>

<style lang="scss" scoped>
.van-cell {
  --van-cell-border-color: none;
  margin-bottom: 15px;
}
.container {
  width: 100%;
  // background: url('../assets/img/detail_background.png') no-repeat;
  background-image: linear-gradient(to bottom,#74b9ed,#fde0d5);
  background-size: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 0 0px 0px 0px;
  position: relative;
}

.header{
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-height: 80vh;
}

.top {
  width: 100%;
}


.middle {
  width: 100%;
}

.image-box {
  position: absolute;
  bottom: 30vw;
  left: 20vw;
}


.btn {
  width: 60vw;
  background: #1EA6FC;
  box-shadow: 0.5px 0.8px 5px white;
}


@media screen and(min-width: 310px)and(max-height: 730px){
  .image {
    width: 88% !important;;
    height: auto;
  }
}

@media screen and(min-width: 414px)and(max-width: 700px){
  .image {
    width: 90% !important;;
    height: auto;
  }
}

@media screen and(height: 812px)and(max-height: 812px){
  .grid-item {
    width: 84% !important; 
  }
}
</style>
